<template>
  <v-card flat class="transparent d-print-none">
    <v-card-text class="px-0 py-1 align-items-center">
      <v-icon small left color="accent">mdi-share-variant</v-icon>
      <v-btn icon :href="twitterShare" target="_blank" rel="noopener" aria-label="Share via Twitter">
        <v-icon color="blue">mdi-twitter</v-icon>
      </v-btn>
      <v-btn icon :href="facebookShare" target="_blank" rel="noopener" aria-label="Share via Facebook">
        <v-icon color="blue darken-4">mdi-facebook</v-icon>
      </v-btn>
      <v-btn icon :href="whatsappShare" target="_blank" rel="noopener" aria-label="Share via Whatsapp">
        <v-icon color="green accent-4">mdi-whatsapp</v-icon>
      </v-btn>
      <v-btn icon :href="telegramShare" target="_blank" rel="noopener" aria-label="Share via Telegram">
        <v-icon color="blue">mdi-telegram</v-icon>
      </v-btn>
      <v-btn icon :href="linkedinShare" target="_blank" rel="noopener" aria-label="Share via Linkedin">
        <v-icon color="blue darken-2">mdi-linkedin</v-icon>
      </v-btn>
      <v-btn icon :href="emailShare" target="_blank" rel="noopener" aria-label="Share via Email">
        <v-icon color="secondary">mdi-email</v-icon>
      </v-btn>
      <v-btn icon class="d-none d-sm-inline-flex" aria-label="Print article">
        <v-icon color="secondary">mdi-printer</v-icon>
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'PostSocial',

    props: ['link', 'title'],

    computed: {
      facebookShare() {
        return 'https://www.facebook.com/sharer.php?u=' + this.link
      },
      twitterShare() {
        return 'https://twitter.com/intent/tweet?url=' + this.link + '&text=' + this.title + '&via=conhome'
      },
      whatsappShare() {
        return 'whatsapp://send?text=' + this.link
      },
      telegramShare() {
        return 'https://telegram.me/share/url?url=' + this.link + '&text=' + this.title
      },
      emailShare() {
        return 'mailto:?subject=' + this.title + '&body=' + this.link
      },
      linkedinShare() {
        return 'https://www.linkedin.com/sharing/share-offsite/?url=' + this.link
      }
    }
  }
</script>
